import {inject, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {UserStatus} from '../types/user';

@Pipe({
  name: 'userStatus',
  standalone: false,
})
export class UserStatusPipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  transform(value: UserStatus): string {
    switch (value) {
      case UserStatus.PENDING:
        return this.translate.instant('users.status.pending');
      case UserStatus.ACTIVE:
        return this.translate.instant('users.status.active');
      case UserStatus.BLOCKED:
        return this.translate.instant('users.status.blocked');
      default:
        return this.translate.instant('users.status.inactive');
    }
  }
}
